<template>
  <div class="w-full">
    <mia-wait :for="['loading document']">
      <template #waiting>
        <div class="flex items-center justify-center py-8">
          <mia-wave-loader />
        </div>
      </template>
      <h1>Archiv bearbeiten</h1>

      <mia-documents-form
        v-model="form"
        :disabled="disabled"
        :errors-key="backendValidationErrorsKey"
        @submit="save"
      >
        <template #actions>
          <mia-submit-button
            label="Archiv speichern"
            :disabled="$wait.any"
            :is-loading="$wait.is('saving provision')"
          />
        </template>
      </mia-documents-form>
    </mia-wait>
  </div>
</template>

<script>
import { getDocument, updateDocument } from '@/api/documents'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import DocumentsForm from '@/components/documents/DocumentsForm.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'

export default {
  name: 'MiaProvisionsAdd',

  components: {
    'mia-documents-form': DocumentsForm,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  data() {
    return {
      disabled: false,
      form: {
        item_title: '',
        item_customer_id: 0,
        item_custom_email: '',
        item_note: '',
        item_firstname: '',
        item_name: '',
        item_email: '',
        item_businessmodel: '',
        item_businesstype: '',
        item_cartype: '',
        item_isLeasing: false,
        item_attachments: []
      }
    }
  },
  computed: {
    documentId() {
      return this.$route.params.id
    }
  },

  mounted() {
    eventBus.$emit('mia-loading-ended')
  },

  created() {
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/documents/list'
        },
        text: 'Dokumente verwalten'
      },
      {
        link: {
          path: '/documents/add'
        },
        text: 'Bearbeiten'
      }
    ])
    this.loadDocument()
  },

  methods: {
    async loadDocument() {
      this.$wait.start('loading document')
      const [error, response] = await getDocument(this.documentId)
      this.$wait.end('loading document')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Der Eintrag konnte nicht geladen werden']
        })
        return
      }

      this.initForm(response.documents)
    },

    initForm(data) {
      this.$set(this.form, 'item_title', data.item_title)
      this.$set(this.form, 'item_customer_id', data.item_customer_id)
      this.$set(this.form, 'item_custom_email', data.item_custom_email)
      this.$set(this.form, 'item_token', data.item_token)
      this.$set(this.form, 'item_file_meta', data.item_file_meta)
      this.$set(this.form, 'item_firstname', data.item_firstname)
      this.$set(this.form, 'item_name', data.item_name)
      this.$set(this.form, 'item_email', data.item_email)
      this.$set(this.form, 'item_note', data.item_note)
      this.$set(this.form, 'item_businessmodel', data.item_businessmodel)
      this.$set(this.form, 'item_businesstype', data.item_businesstype)
      this.$set(this.form, 'item_cartype', data.item_cartype)
      this.$set(this.form, 'item_isLeasing', parseInt(data.item_isLeasing) === 1)
      this.$set(this.form, 'item_attachments', data.item_attachments)
      this.disabled = parseInt(data.item_email_send) === 1
    },

    async save() {
      const payload = new FormData()
      payload.append('id', this.documentId)
      payload.append('item_title', this.form.item_title)
      payload.append('item_customer_id', this.form.item_customer_id)
      payload.append('item_custom_email', this.form.item_custom_email)
      payload.append('item_businessmodel', this.form.item_businessmodel)
      payload.append('item_businesstype', this.form.item_businesstype)
      payload.append('item_cartype', this.form.item_cartype)
      payload.append('item_isLeasing', this.form.item_isLeasing)
      payload.append('item_note', this.form.item_note)

      this.form.item_attachments.forEach((attachment) => {
        payload.append('item_attachments[]', attachment.fileInstance ? attachment.fileInstance : attachment.id)
      })

      this.$wait.start('update document')
      const [error, response] = await updateDocument(payload)
      this.$wait.end('update document')


      if (error || !response.success) {
        this.$emit('failed')
        return
      }

      eventBus.$emit('mia-info', {
        info: [response.message]
      })

      this.loadDocument()
    }
  }
}
</script>
